import styled from 'styled-components';

export const Container = styled.div`
  display: inline-flex;
  align-items: flex-start;
  min-height: 40px;
  max-width: 100%;
`;

export const DropdownHandler = styled.span<{ $disabled?: boolean }>`
  flex: none;
  padding: 0 4px;
  margin-top: 2px;
  border-radius: 4px;
  font-size: 24px;
  color: #8c8c8c;

  ${({ $disabled }) => {
    if ($disabled) {
      return `cursor: not-allowed;`;
    }

    return `
    cursor: pointer;

    :hover {
      color: #295cdc;
      background-color: rgb(0 0 0 / 6%);
    }
      `;
  }}

  > span.anticon:nth-of-type(2) {
    margin-left: -4px;
    margin-right: -4px;
  }
`;
